export default function OutboundStatusUpdate(params) {
    document.dispatchEvent(new CustomEvent('outbound_status_update', {
        detail: params
    }));
}